import { licenseServices } from "../../Components/License/services/license.bank.service";
/**
 *
 * @param {Object} logout keyloak logout fn
 * @param {String} licenseId license id
 */
export const logoutHandler = (logout, licenseId) => {
  const tokenData = localStorage.getItem("corzapAuth");
  const json = JSON.parse(tokenData);
  licenseServices
    .inValidateLicense(licenseId, { token: json.token })
    .then(() => {
      localStorage.removeItem("corzapAuth");
      // logout({
      //   redirectUri: `${window.location.protocol}/${window.location.host}/`,
      // });
      logout();
    })
    .catch((e) => alert(e.message));
};
